<template>
  <div>
    <slot name="prev"/>
    <app-link :to="$options.PAGES.TERMS">
      {{ $t('Terms & Conditions') }}
    </app-link>
    <slot name="middle"/>
    <app-link :to="$options.PAGES.POLICY">
      {{ $t('Privacy Policy') }}
    </app-link>
    <slot name="after"/>
  </div>
</template>

<script>
import AppLink from '@/components/base-components/AppLink.vue';
import {POLICY, TERMS} from '@/pages';

export default {
  name: 'termsPolicy',
  components: {
    AppLink,
  },
  PAGES: {
    POLICY,
    TERMS,
  },

};
</script>

<style scoped lang="scss">
@import "src/assets/css/colors";

a {
  cursor: pointer;
  text-transform: capitalize;
  color: inherit;
  
  &:hover {
    text-decoration: none;
    color: inherit;
  }
}

.policy-wrapper {
  display: flex;
  flex-direction: column;
  background-color: var(--settings-body-background);
  color: var(--settings-body-text-color);
  max-height: 80vh;
  height: 80rem;
  width: 60rem;
  max-width: 90vw;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: var(--card-shadow);
}

.policy-title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2rem;
  
  .policy-close {
    height: 2rem;
    width: 2rem;
  }
}

.policy-content {
  overflow-y: auto;
  height: 100%;
  font-weight: 400;
  text-transform: none;
  font-style: normal;
}
</style>
